// libraries
import { Box } from '@interstate/components/Box';
import { Grid } from '@interstate/components/Grid';
import { Typography } from '@interstate/components/Typography';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

// material-ui
import { LinearProgress } from '@material-ui/core';

//Styles
import useStyles from './RiskSlider.style';

//props
interface RiskSliderProps {
    riskLevel: number;
    leftLabel?: string;
    rightLabel?: string;
    riskSteps?: number;
}

export const RiskSlider = ({ riskLevel, leftLabel, rightLabel, riskSteps = 6 }: RiskSliderProps) => {
    const theme = useInterstateTheme();
    const { BaseColorGray600 } = theme.tokens;
    const riskLevels = Array.from({ length: riskSteps });

    const riskValue = (riskLevel / (riskSteps - 1)) * 100;

    const classes = useStyles({
        riskLevel,
        riskSteps,
        customTheme: theme
    });

    return (
        <Grid container direction="column">
            <Grid className={classes.labelWrapper} container justifyContent="space-between">
                <Typography data-testid="Low-risk-label" variant="body-sm" color={BaseColorGray600}>
                    {leftLabel}
                </Typography>
                <Typography data-testid="high-risk-label" variant="body-sm" color={BaseColorGray600}>
                    {rightLabel}
                </Typography>
            </Grid>
            <LinearProgress
                classes={{
                    root: classes.root,
                    colorPrimary: classes.colorPrimary,
                    bar: classes.bar
                }}
                value={riskValue}
                variant="determinate"
            />
            <Grid className={classes.riskLevelWrapper} container>
                {riskLevels.map((item, index) => {
                    const key = `${JSON.stringify(item)}-${index}`;
                    return (
                        <Box key={key} display="flex" alignItems="center" justifyContent="center">
                            <Typography variant="body-sm">{index}</Typography>
                        </Box>
                    );
                })}
            </Grid>
        </Grid>
    );
};
